<template>
  <div class="ui tiny empty circular horizontal label" :class="size" :style="labelStyle" />
</template>

<script>
// @flow
import _ from 'lodash'

export default {
  name: 'color-label',
  props: {
    size: String,
    color: String
  },
  data() {
    return {
      ignoredColors: ['#f2f2f2']
    }
  },
  computed: {
    isColorIgnored() {
      return _.includes(this.ignoredColors, this.color)
    },
    labelStyle() {
      return this.color && !this.isColorIgnored
        ? { backgroundColor: this.color }
        : { backgroundColor: 'transparent' }
    }
  }
}
</script>
